let data36;
if (typeof window === "undefined") {
  data36 = require("../static-s36/Data.json");
} else {
  data36 = window.data36;
}

export { data36 };
